import { geInboxEntryAllowClose } from './InboxEntry';

import {
  EmailEntryListItem,
  EmailFileEntry,
  InboxEntryStatus,
  UserWithFullNameAndEmail,
  UserWithFullNameAndEmailAndAvatar,
} from '../types';

export const mapEmailEntryListItem = (rawResponse): EmailEntryListItem => {
  // filter actual attachments from inline images
  const emailAttachments = rawResponse.attachments.filter((file) => !file.cid);
  return {
    id: rawResponse.id,
    from: rawResponse.from?.map((from): UserWithFullNameAndEmailAndAvatar => {
      return {
        fullName: from.name,
        emailAddress: from.address,
        avatar: from.avatar || 'default.png',
      };
    }),
    cc:
      rawResponse.cc?.map((cc): UserWithFullNameAndEmail => {
        return {
          fullName: cc.name,
          emailAddress: cc.address,
        };
      }) || [],
    to: rawResponse.to.map((to): UserWithFullNameAndEmail => {
      return {
        fullName: to.name,
        emailAddress: to.address,
      };
    }),
    html: rawResponse.html,
    text: rawResponse.text,
    subject: rawResponse.subject,
    dateAdded: rawResponse.date,
    emailType: rawResponse.type,
    files: {
      list: emailAttachments.map((efe): EmailFileEntry => {
        return {
          emailId: rawResponse.id,
          file: {
            id: efe.id,
            name: efe.name,
            status: efe.status,
            isRead: efe.read,
            allowedStatusChanges: efe['allowed-status-changes'],
            allowClose: geInboxEntryAllowClose(efe['allow-close']),
            duplicate: efe.duplicate,
          },
        };
      }),
      total: emailAttachments.length,
    },
    status: rawResponse.status,
    isRead: rawResponse.read,
    isDeleted: rawResponse.trash,
    duplicate: rawResponse.duplicate,
    inboxEntryId: rawResponse.inboxEntryId,
    allowedStatusChanges: rawResponse['allowed-status-changes'],
    allowClose: geInboxEntryAllowClose(rawResponse['allow-close']),
  };
};

const ACTIVE_STATUSES = [InboxEntryStatus.Open.toLowerCase(), InboxEntryStatus.New.toLowerCase()];

export const getOpenInboundAttachmentsCount = (files) =>
  files.filter((f) => ACTIVE_STATUSES.includes(f.file.status?.toLowerCase())).length;

export const getUserWithFullNameAndEmaiDisplayValue = (from: UserWithFullNameAndEmail) => {
  if (from.fullName && from.emailAddress) {
    return `${from.fullName} <${from.emailAddress}>`;
  }

  if (from.fullName && !from.emailAddress) {
    return `${from.fullName}`;
  }

  return `${from.emailAddress}`;
};
